/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import http from '@/utils/http/axios';
import type {
  MedicineApi,
  DeptListPageCmb,
  OpearteList,
  TakeRemarks
} from './types';

const yApiObj = {
  // yapi: 1271
};

enum Api {
  medicineList = '/front-end/survey/api/v1/surveys',
  enabled = '/front-end/survey/api/v1/enabled',
  delete = '/front-end/survey/api/v1/delete/:id/:sceneType',
  medicineList2 = '/front-end/surveyTemplate/api/v1/surveyTemplates',
  enabled2 = '/front-end/surveyTemplate/api/v1/enabled',
  delete2 = '/front-end/surveyTemplate/api/v1/delete/:id/:sceneType',

  isEdit = '/front-end/survey/api/v1/checkEditable/:id/:sceneType', // 校验是否可编辑
  deptListPageCmb = '/front-end/entp/user/api/v1/deptListPageCmb', // 客户名称-下拉框数据
  opearteList = '/front-end/form/opearte/api/v1/list', // 【表单管理】- 表单操作日志列表
  takeRemarks = '/front-end/form/opearte/api/v1/takeRemarks', // 【表单管理】- 添加备注

  getSurvey = '/front-end/survey/api/v1/getSurvey', // 【医学表单】获取表单详情
  getSurveyTemplate = '/front-end/surveyTemplate/api/v1/getSurveyTemplate', // 【表单模板】获取表单详情
  questionsTypes = '/front-end/project/fe/survey/questionsTypes' // 题型列表
}

/** 医学表单 */
export const medicineApi: MedicineApi = {
  /** 列表 */
  list: async params => {
    return http.request(
      {
        url: Api.medicineList,
        method: 'POST',
        params
      },
      {
        ...yApiObj
      }
    );
  },
  enabled: async params => {
    return http.request(
      {
        url: Api.enabled,
        method: 'POST',
        params
      },
      {
        ...yApiObj
      }
    );
  },
  delete: async params => {
    return http.request(
      {
        url: Api.delete,
        method: 'GET',
        params
      },
      {
        ...yApiObj
      }
    );
  },
  isEdit: async params => {
    return http.request(
      {
        url: Api.isEdit,
        method: 'GET',
        params
      },
      {
        ...yApiObj
      }
    );
  }
};

/** 表单模板 */
export const templateApi: Omit<MedicineApi, 'isEdit'> = {
  /** 列表 */
  list: async params => {
    return http.request(
      {
        url: Api.medicineList2,
        method: 'POST',
        params
      },
      {
        ...yApiObj
      }
    );
  },
  enabled: async params => {
    return http.request(
      {
        url: Api.enabled2,
        method: 'POST',
        params
      },
      {
        ...yApiObj
      }
    );
  },
  delete: async params => {
    return http.request(
      {
        url: Api.delete2,
        method: 'GET',
        params
      },
      {
        ...yApiObj
      }
    );
  }
};

export const deptListPageCmb: DeptListPageCmb = async params => {
  return http.request(
    {
      url: Api.deptListPageCmb,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
};

export const opearteList: OpearteList = async params => {
  return http.request(
    {
      url: Api.opearteList,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
};

export const takeRemarks: TakeRemarks = async params => {
  return http.request(
    {
      url: Api.takeRemarks,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
};

/** 医学表单 - 导出详情 */
export const formSurveyApi = {
  getSurvey: async (params: { id: number; sceneType: number }) => {
    return http.request(
      {
        url: Api.getSurvey,
        method: 'GET',
        params
      },
      {
        ...yApiObj
      }
    );
  },
  questionsTypes: async (params?) => {
    return http.request(
      {
        url: Api.questionsTypes,
        method: 'GET',
        params
      },
      {
        ...yApiObj
      }
    );
  }
};

/** 表单模板 - 导出详情 */
export const formTemplateSurveyApi = {
  getSurvey: async (params: { id: number; sceneType: number }) => {
    return http.request(
      {
        url: Api.getSurveyTemplate,
        method: 'GET',
        params
      },
      {
        ...yApiObj
      }
    );
  }
};
